<mat-sidenav-container class="layout-container">
  <!-- Sidebar -->
  <mat-sidenav #sidenav
               class="layout-sidenav"
               [mode]="sidenavMode"
               [opened]="sidenavOpened"
               [fixedInViewport]="true"
               [disableClose]="false">
    <app-shared-sidebar
      [menuItems]="menuItems"
      [currentRoute]="currentRoute"
      (menuItemClick)="onMenuItemClick($event)">
    </app-shared-sidebar>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content class="layout-content">
    <!-- Top Toolbar -->
    <mat-toolbar color="primary" class="layout-toolbar">
      <!-- Mobile Menu Button -->
      <button mat-icon-button
              class="mobile-menu-button"
              (click)="toggleSidenav()"
              [class.hidden]="sidenavOpened">
        <mat-icon>menu</mat-icon>
      </button>

      <!-- Page Title -->
      <span class="toolbar-title">Extecamp - Escola de Extensão da Unicamp</span>

      <span class="toolbar-spacer"></span>

      <!-- Navigation Icons -->
      <button mat-icon-button
              title="Início"
              (click)="goHome()"
              class="toolbar-button">
        <mat-icon>home</mat-icon>
      </button>

      <!-- Notifications -->
      <button mat-icon-button
              [matMenuTriggerFor]="notificationsMenu"
              title="Notificações"
              class="toolbar-button">
        <mat-icon [matBadge]="unreadCount"
                  [matBadgeHidden]="!unreadCount"
                  aria-hidden="false"
                  matBadgeColor="warn">notifications</mat-icon>
      </button>

      <!-- Theme Toggle -->
      <app-theme-toggle></app-theme-toggle>

      <!-- Font Size Toggle -->
      <app-font-size-toggle></app-font-size-toggle>

      <!-- Logout -->
      <button mat-icon-button
              color="warn"
              title="Sair"
              (click)="logout()"
              class="toolbar-button">
        <mat-icon>logout</mat-icon>
      </button>
    </mat-toolbar>

    <!-- Notifications Menu -->
    <mat-menu #notificationsMenu="matMenu" class="notifications-menu">
      <div class="notifications-header">
        <h3>Avisos</h3>
      </div>
      <mat-divider></mat-divider>
      <div class="notifications-list">
        @if (avisos.length === 0) {
          <div class="empty-notifications">
            <mat-icon>notifications_none</mat-icon>
            <p>Nenhum aviso</p>
          </div>
        } @else {
          @for (aviso of avisos; track aviso.id) {
            <div class="notification-item">
              <div class="notification-icon">
                <mat-icon >
                  {{ getNotificationIcon('info') }}
                </mat-icon>
              </div>
              <div (click)="clickNotification()" class="notification-content">
                <div class="notification-title">{{ aviso.titulo }}</div>
                <div class="notification-time">{{ aviso.inicio_exibicao| date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
            </div>
          }
        }
      </div>
    </mat-menu>

    <!-- Page Content -->
    <div class="page-content">
      <!-- <ng-content></ng-content> -->
      <router-outlet></router-outlet>
    </div>

    <!-- Help FAB Button -->
    <app-help-fab-button></app-help-fab-button>
  </mat-sidenav-content>
</mat-sidenav-container>
